import gql from 'graphql-tag';
import React from 'react';
import { Text } from '../../components';
import SearchDropdownSelector from './SearchDropdownSelector';

const GET_PLANOGRAMS = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: PlanogramPageFilter
	) {
		getPlanograms(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				name
			}
			count
		}
	}
`;

const PlanogramSelector = ({ query, ...props }) => {
	return (
		<SearchDropdownSelector
			query={query || GET_PLANOGRAMS}
			initialFilter={{
				isIngredient: false,
				template: true,
			}}
			renderItem={item => <Text>{ item.name }</Text>}
			renderLabel={item => <Text>{ item.name }</Text>}
			placeholder="Select planogram"
			{...props}
		/>
	);
};

export default PlanogramSelector;
